import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import SelectProfile from "@/pages/SelectProfile";
import NewQuote from "@/pages/client/NewQuote";
import ClientOrders from "@/pages/client/ClientOrders";
import ClientOrderDetail from "@/pages/client/ClientOrderDetail";
import CompanyOrders from "@/pages/company/CompanyOrders";
import CompanyOrderDetail from "@/pages/company/CompanyOrderDetail";
import CompanyVendors from "@/pages/company/CompanyVendors";
import CompanyInstallers from "@/pages/company/CompanyInstallers";
import AdminRequests from "@/pages/admin/AdminRequests";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminOrders from "@/pages/admin/AdminOrders";
import AdminOrderDetail from "@/pages/admin/AdminOrderDetail";
import AdminDelivery from "@/pages/admin/AdminDelivery";
import AdminPickupMode from "@/pages/admin/AdminPickupMode";
import AdminServices from "@/pages/admin/AdminServices";
import AdminAgenda from "@/pages/admin/AdminAgenda";
import Profile from "@/pages/Profile";
import AdminCompanies from "@/pages/admin/AdminCompanies";

function HomeRedirect() {
  const { user } = useAuth();
  if (user === undefined) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "admin") return <Navigate to="/admin" replace />;
  if (user.vendor) return <Navigate to="/client" replace />;
  return <Navigate to="/select-profile" replace />;
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/select-profile" element={<ProtectedRoute><SelectProfile /></ProtectedRoute>} />

          {/* Client (vendor session required) */}
          <Route path="/client" element={<ProtectedRoute requireVendor><Layout><Navigate to="/client/new" replace /></Layout></ProtectedRoute>} />
          <Route path="/client/new" element={<ProtectedRoute requireVendor><Layout><NewQuote /></Layout></ProtectedRoute>} />
          <Route path="/client/orders" element={<ProtectedRoute requireVendor><Layout><ClientOrders /></Layout></ProtectedRoute>} />
          <Route path="/client/orders/:id" element={<ProtectedRoute requireVendor><Layout><ClientOrderDetail /></Layout></ProtectedRoute>} />

          {/* Company admin (no vendor session) */}
          <Route path="/company" element={<ProtectedRoute requireCompanyAdmin><Layout><Navigate to="/company/orders" replace /></Layout></ProtectedRoute>} />
          <Route path="/company/orders" element={<ProtectedRoute requireCompanyAdmin><Layout><CompanyOrders /></Layout></ProtectedRoute>} />
          <Route path="/company/orders/:id" element={<ProtectedRoute requireCompanyAdmin><Layout><CompanyOrderDetail /></Layout></ProtectedRoute>} />
          <Route path="/company/vendors" element={<ProtectedRoute requireCompanyAdmin><Layout><CompanyVendors /></Layout></ProtectedRoute>} />
          <Route path="/company/installers" element={<ProtectedRoute requireCompanyAdmin><Layout><CompanyInstallers /></Layout></ProtectedRoute>} />

          {/* Admin */}
          <Route path="/admin" element={<ProtectedRoute requireAdmin><Layout><Navigate to="/admin/requests" replace /></Layout></ProtectedRoute>} />
          <Route path="/admin/requests" element={<ProtectedRoute requireAdmin><Layout><AdminRequests /></Layout></ProtectedRoute>} />
          <Route path="/admin/dashboard" element={<ProtectedRoute requireAdmin><Layout><AdminDashboard /></Layout></ProtectedRoute>} />
          <Route path="/admin/agenda" element={<ProtectedRoute requireAdmin><Layout><AdminAgenda /></Layout></ProtectedRoute>} />
          <Route path="/admin/orders" element={<ProtectedRoute requireAdmin><Layout><AdminOrders /></Layout></ProtectedRoute>} />
          <Route path="/admin/orders/:id" element={<ProtectedRoute requireAdmin><Layout><AdminOrderDetail /></Layout></ProtectedRoute>} />
          <Route path="/admin/orders/:id/delivery" element={<ProtectedRoute requireAdmin><Layout><AdminDelivery /></Layout></ProtectedRoute>} />
          <Route path="/admin/orders/:id/pickup" element={<ProtectedRoute requireAdmin><Layout><AdminPickupMode /></Layout></ProtectedRoute>} />
          <Route path="/admin/services" element={<ProtectedRoute requireAdmin><Layout><AdminServices /></Layout></ProtectedRoute>} />
          <Route path="/admin/companies" element={<ProtectedRoute requireAdmin><Layout><AdminCompanies /></Layout></ProtectedRoute>} />

          <Route path="/profile" element={<ProtectedRoute><Layout><Profile /></Layout></ProtectedRoute>} />

          <Route path="/" element={<HomeRedirect />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
